export default __webpack_public_path__ + "static/media/State Farm.f6615aa9.svg";